/* eslint-disable max-len */
import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

import Color from '@tool/color';
import { BrowseIcon, PhoneIcon3 } from '@/styled/icon';
import moCapital from '../store/capital-analysis';
import { isEmpty } from 'lodash';

interface IProps { }
interface IState { }

const CapitalChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const [active, setActive] = useState(false);
  const [names, setNames] = useState('');
  const { capitalList, capitalTabActive } = moCapital;

  const emen: any = {
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    元均营业收入: 'revenue_per_yuan',
    元均净利润: 'profit_per_yuan',
  };

  const getData = useMemo(() => {
    const active = emen[capitalTabActive];
    let list: any = [];
    if (!isEmpty(capitalList)) {
      list = capitalList?.chart_data[active];
    }
    return list;
  }, [capitalList, capitalTabActive]);

  const changeShow = () => {
    setActive(!active);
  };

  useEffect(() => {
    return () => {
    };
  }, []);

  return (
    <section className="capital-chart-warp">
      <p className='chart-check'
        style={{
          color: active ? Color.primary : Color.c55,
        }} onClick={changeShow}>
        <BrowseIcon width={16} height={16}
          color={active ? Color.primary : Color.c55} />
        {active ? '隐藏' : '显示'}公司名称
      </p>
      <section className='chart-top'>
        <p className='chart-left-title'>人力资本产出<span>｜{capitalTabActive}</span></p>
        <p className="chart-left-num">
          <span>0</span><span>20</span><span>40</span><span>60</span><span>80</span><span>100</span>
        </p>
        <section className='chart-content'>
          <section className='show-table'>
            <span></span><span></span><span></span><span></span><span></span><span></span>
            <span></span><span></span><span></span><span></span><span></span><span></span>
            <span></span><span></span><span></span><span></span><span></span><span></span>
            <span></span><span></span><span></span><span></span><span></span><span></span>
            <span></span>
          </section>
          <b>红牌区</b><b>警戒区</b><b>预期区</b>
          {
            getData?.map((res: any, r: any) => {
              return <p key={`${r}`} className="item-pointer"
                style={{
                  position: 'absolute',
                  left: `${res.x}%`,
                  bottom: `${res.y}%`,
                }}>
                <i
                  style={{ background: res.company_name === '您所在公司' ? Color.secondary : Color.primary }}
                  onMouseEnter={() => { setNames(res.company_name); }}
                  onMouseLeave={() => { setNames(''); }} />
                {
                  (active || names === res.company_name) &&
                  <span
                    style={{
                      color: res.company_name === '您所在公司' ? Color.secondary : Color.blackColor(1),
                    }}>
                    {res.company_name}
                  </span>
                }
              </p>;
            })
          }
        </section>
      </section>
      <p className="chart-bot-num">
        <span>0</span><span>20</span><span>40</span><span>60</span><span>80</span><span>100</span>
      </p>
      <p className='chart-bot'>人力资本投入<span>-人均薪酬成本</span></p>
    </section >
  );
};

export default observer(CapitalChart);
